import React, { useState, useEffect } from "react";
import SubPage from "../../Common/SubPage";
import { MdOutlineArrowBack } from "react-icons/md";
import BodyContent from "../../Common/BodyContent";
import GoBackButton from "../PhysicianProfile/GoBackButton";
import CheckboxContainer from "./CheckboxContainer";
import { useNavigate, useLocation, useNavigationType } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import * as actions from "../../../redux/actions";
import ScrollToTop from "../../Common/HOC/ScrollToTop";
import Styled from "./styles";
import { getEffectiveDateFrom } from "../../../utils/Utils";

const SelectToPrint = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const navigationType = useNavigationType();
  const setSelectedItemsToPrint = useSelector(
    ({ setSelectedItemsToPrint }) => setSelectedItemsToPrint
  );
  const itemStructure = [
    {
      name: "officeInfoOnly",
      label: "Office information only",
    },
    {
      name: "allInfo",
      label: "All information about the physician",
    },
    {
      name: "educationSection",
      label: "All of Education section",
      childrens: [
        {
          name: "medicalSchool",
          label: "Medical school",
        },
        {
          name: "graduateMedEdu",
          label: "Graduate medical education",
        },
        {
          name: "boardCertification",
          label: "Board certifications",
        },
        {
          name: "professionalMembership",
          label: "Professional membership",
        },
      ],
    },
    {
      name: "practiceInfoSection",
      label: "All of Practice info section",
      childrens: [
        {
          name: "fieldOfPractice",
          label: "Field of medicine",
        },
        {
          name: "hivServices",
          label: "HIV services",
        },
        {
          name: "offices",
          label: "Offices",
        },
        {
          name: "translationServices",
          label: "Languages available",
        },
        {
          name: "govtInsuranceProg",
          label: "Medicaid and other government insurance programs",
        },
        {
          name: "healthPlans",
          label: "Health plans",
        },
        {
          name: "hospitalPriveleges",
          label: "Hospital privileges",
        },
      ],
    },
    {
      name: "legalActionsSection",
      label: "All of Legal actions section",
      childrens: [
        {
          name: "malpractice",
          label: "Malpractice",
        },
        {
          name: "liscenseeActions",
          label: "NY Licensee actions",
        },
        {
          name: "outOfStateActions",
          label: "Out-of-state actions",
        },
        {
          name: "currentLimitations",
          label: "Current limitations or conditions",
        },
        {
          name: "hospitalRestictions",
          label: "Hospital privilege restrictions",
        },
        {
          name: "hospitalFailure",
          label: "Hospital failure to renew privileges",
        },
        {
          name: "criminalConvictions",
          label: "Criminal convictions",
        },
      ],
    },
    {
      name: "professionalActivitiesSection",
      label: "All of Professional activities section",
      childrens: [
        {
          name: "academicAppointments",
          label: "Teaching responsibilities",
        },
        {
          name: "communityServiceActivities",
          label: "Professional and community service activities",
        },
        {
          name: "publications",
          label: "Publications",
        },
      ],
    },
    {
      name: "healthPlansSection",
      label: "Health plans",
      childrens: [
        {
          name: "providerNetwork",
          label: "Provider network",
        },
        {
          name: "healthPlansPnds",
          label: "Health plans",
        },
      ],
    },
    {
      name: "statement",
      label: "Statement",
    },
  ];
  const { licenseNumber, lastName } = useSelector(
    ({ physicianProfileInfo }) => physicianProfileInfo
  );
  const [selectedItems, setSelectedItems] = useState({});
  const { state } = useLocation();
  if (!state) {
    window.location.href = window.location.origin;
  }
  const { physicianId } = state;
  const properties = {
    titleBlue: "SELECT ITEMS TO",
    titleBlack: "Print",
  };
  const goToPrinterFriendlyPage = () => {
    dispatch(actions.setSelectedItemsToPrint(selectedItems));
    navigate("/printer-friendly", { state: { physicianId: physicianId } });
  };

  useEffect(() => {
    if (navigationType === "POP") {
      setSelectedItems({ ...setSelectedItemsToPrint });
    }
  }, [setSelectedItemsToPrint, navigationType]);

  return (
    <SubPage properties={properties}>
      <BodyContent>
        <Styled>
          <GoBackButton
            buttonContent={
              <>
                <MdOutlineArrowBack />
                <span>Go back to previous page</span>
              </>
            }
          />
          <div className="content">
            <p>
              Check the box next to the information you want to print. Print it
              out by clicking the "
              <span className="colored-text">
                <strong>Printer friendly page</strong>
              </span>
              " button.
            </p>
            <p>
              Any actions taken against a physician's license to practice
              medicine in New York State are not included in this printout. You
              may click here (
              <a
                href={`https://apps.health.ny.gov/pubdoh/professionals/doctors/conduct/factions/ByPhysician?SearchView&Query=(FIELD+PhysicianName=${lastName}+AND+FIELD+WebLicense=${licenseNumber}+AND+FIELD+EffectiveDateFrom=${getEffectiveDateFrom()})`}
                target="opmc_window"
              >
                OPMC site
              </a>
              ) for copies of disciplinary actions found on the{" "}
              <strong>Legal Actions</strong> section of the website.
            </p>
          </div>
          <CheckboxContainer
            checkboxStructure={itemStructure}
            selectedItems={selectedItems}
            setSelectedItems={setSelectedItems}
          />
          <button
            className="btn printer-friendly-btn"
            onClick={goToPrinterFriendlyPage}
          >
            Printer friendly page
          </button>
        </Styled>
      </BodyContent>
    </SubPage>
  );
};

export default ScrollToTop(SelectToPrint);
